const services = [
  {
    icon: 'ri-settings-3-line',
    title: 'Lavorazioni Meccaniche',
    description: 'Lavorazioni meccaniche di precisione conto terzi con macchinari all\'avanguardia e personale altamente qualificato per garantire risultati eccellenti.',
    features: ['Tornitura CNC', 'Fresatura', 'Foratura', 'Rettifica']
  },
  {
    icon: 'ri-building-line',
    title: 'Ferro per Edilizia',
    description: 'Commercio all\'ingrosso di ferro e materiali ferrosi per costruzioni edili, con ampia disponibilità di prodotti e consegne rapide su tutto il territorio nazionale.',
    features: ['Travi in acciaio', 'Profilati', 'Lamiere', 'Tondini']
  },
  {
    icon: 'ri-hammer-line',
    title: 'Strutture Metalliche',
    description: 'Progettazione e realizzazione di strutture metalliche su misura per applicazioni edili e meccaniche, con soluzioni personalizzate per ogni esigenza.',
    features: ['Carpenteria', 'Telai', 'Scaffalature', 'Soppalchi']
  },
  {
    icon: 'ri-tools-line',
    title: 'Supporto Tecnico',
    description: 'Consulenza tecnica specializzata e supporto operativo personalizzato per imprese e professionisti del settore, dalla progettazione alla realizzazione.',
    features: ['Consulenza', 'Progettazione', 'Assistenza', 'Collaudo']
  },
  {
    icon: 'ri-truck-line',
    title: 'Logistica Nazionale',
    description: 'Servizio di consegna capillare su tutto il territorio italiano con puntualità garantita e tracciabilità completa delle spedizioni.',
    features: ['Consegne rapide', 'Tracciamento', 'Imballaggio sicuro', 'Gestione urgenze']
  },
  {
    icon: 'ri-global-line',
    title: 'Espansione Internazionale',
    description: 'Sviluppo di partnership commerciali all\'estero per portare la qualità italiana nel mondo, con servizi dedicati all\'export.',
    features: ['Export', 'Partnership', 'Certificazioni', 'Assistenza multilingua']
  }
];

export default function Services() {
  return (
    <section id="servizi" className="py-24 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
            I Nostri Servizi
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Soluzioni complete per il settore edile e meccanico, con un'offerta integrata che spazia dalle lavorazioni di precisione alla fornitura di materiali
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-slate-100 group hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-slate-700 to-slate-900 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">
                {service.title}
              </h3>
              <p className="text-slate-600 mb-6 leading-relaxed">
                {service.description}
              </p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-slate-700">
                    <i className="ri-check-line text-slate-700 mr-2"></i>
                    <span className="text-sm">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}